/* ============================================================
   THE SLEEP LOFT — shared reveal-on-scroll observer.
   ------------------------------------------------------------
   One IntersectionObserver for EVERY [data-sl-reveal] container
   on the page.
   ============================================================ */
(function () {
  var root = document.documentElement;
  root.classList.add('sl-reveal-ready');

  var supported = 'IntersectionObserver' in window;
  var io = supported
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sl-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' })
    : null;

  function scan(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sl-reveal]:not(.sl-in)');
    for (var i = 0; i < nodes.length; i++) {
      if (io) {
        io.observe(nodes[i]);
      } else {
        nodes[i].classList.add('sl-in'); // no IO support: reveal immediately
      }
    }
  }

  if (document.readyState !== 'loading') {
    scan();
  } else {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target || document);
  });
})();

/* ============================================================
   THE SLEEP LOFT — policy page quick-nav.
   ============================================================ */
(function () {
  if (!document.body || document.body.className.indexOf('template-policy') === -1) return;

  function buildNav() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container || container.querySelector('.sl-policy-nav')) return;

    var seen = {}, links = [];
    var anchors = document.querySelectorAll('a[href*="/policies/"]');
    for (var i = 0; i < anchors.length; i++) {
      var raw = anchors[i].getAttribute('href') || '';
      var path = raw.split('?')[0].split('#')[0].replace(/^https?:\/\/[^\/]+/, '');
      if (path.indexOf('/policies/') !== 0) continue;
      path = path.replace(/\/$/, '');
      if (seen[path]) continue;
      var label = (anchors[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (!label) continue;
      seen[path] = 1;
      links.push({ path: path, label: label });
    }
    if (links.length < 2) return;

    var current = location.pathname.replace(/\/$/, '');
    var nav = document.createElement('nav');
    nav.className = 'sl-policy-nav';
    nav.setAttribute('aria-label', 'Policies');
    var html = '<span class="sl-policy-nav__label">Policies</span><ul>';
    for (var j = 0; j < links.length; j++) {
      var active = links[j].path === current ? ' class="is-active" aria-current="page"' : '';
      html += '<li><a href="' + links[j].path + '"' + active + '>' + links[j].label + '</a></li>';
    }
    html += '</ul>';
    nav.innerHTML = html;
    container.insertBefore(nav, container.firstChild);
  }

  if (document.readyState !== 'loading') {
    buildNav();
  } else {
    document.addEventListener('DOMContentLoaded', buildNav);
  }
})();

/* ============================================================
   THE SLEEP LOFT — lazy-load Trustindex review widgets.
   ============================================================ */
(function () {
  var pending = [];
  function collect() {
    var nodes = document.querySelectorAll('.ti-lazy[data-ti-src]');
    for (var i = 0; i < nodes.length; i++) pending.push(nodes[i]);
  }

  function load(el) {
    if (!el || el.getAttribute('data-ti-loaded')) return;
    el.setAttribute('data-ti-loaded', '1');
    var s = document.createElement('script');
    s.async = true;
    s.src = el.getAttribute('data-ti-src');
    el.parentNode.insertBefore(s, el.nextSibling);
  }

  function loadAll() {
    for (var i = 0; i < pending.length; i++) load(pending[i]);
  }

  function init() {
    collect();
    if (!pending.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { load(entry.target); io.unobserve(entry.target); }
        });
      }, { rootMargin: '700px 0px' });
      for (var i = 0; i < pending.length; i++) io.observe(pending[i]);
    } else {
      loadAll();
      return;
    }

    var once = function () { loadAll(); remove(); };
    var remove = function () {
      ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
        window.removeEventListener(ev, once, { passive: true });
      });
    };
    ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, once, { passive: true });
    });

    setTimeout(loadAll, 5000);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* ============================================================
   THE SLEEP LOFT — ?directions=1 deep link.  (2026-08-25)
   ------------------------------------------------------------
   External listings (Yelp, Google Business Profile, Bing) can
   only point at ONE url, so they cannot render our multi-app
   "Get directions" chooser themselves. Landing on a showroom
   page with ?directions=1 opens that chooser automatically.

   Scoped to .sl_loc_template27_primary — the footer carries ~20
   other .sl-maps-link elements, one per showroom, so querying
   the first one would open directions to the WRONG store.
   ============================================================ */
(function () {
  if (!/[?&]directions=1(?:&|$)/.test(window.location.search)) return;

  var SELECTOR = '.sl_loc_template27_primary.sl-maps-link';
  var POLL_MS = 125;
  var MAX_TRIES = 40;

  function openChooser() {
    var btn = document.querySelector(SELECTOR);
    if (!btn) return false;
    btn.click();
    return true;
  }

  function start() {
    if (openChooser()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (openChooser() || ++tries > MAX_TRIES) clearInterval(timer);
    }, POLL_MS);
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();

/* ============================================================
   THE SLEEP LOFT — ID.me community discount bar.
   (2026-08-26)
   ------------------------------------------------------------
   Places a military / first-responder / nurse / teacher /
   student verification bar in two spots:

   PRODUCT PAGE — in the buy box, directly under the Medpaid
   HSA-FSA bar, so the two benefit bars read as a matched pair:
     A.sl-instore-cta   — "Try in store today"
     DIV.mp-widget      — Medpaid HSA | FSA bar
     >> verification bar goes here <<
     DIV.sl-pdp-trust   — trial / delivery / APR / returns

   CART PAGE — inside .cart__blocks, directly ABOVE the Affirm
   financing block (so: below Check out and below the Shop Pay /
   PayPal / G Pay wallet row), putting the two "ways to pay less"
   together at the foot of the order summary.

   Deliberate choices:

   1. Points at /pages/idme — the ID.me-generated landing page,
      which carries ID.me's own Verify button. We deliberately do
      NOT hardcode ID.me's discountify.id.me OAuth URL here: if
      ID.me ever rotates it, the landing page follows and this
      bar keeps working.

   2. Opens in a new tab so the shopper does not lose the product
      they were looking at — ID.me's post-verification page
      redirects to the homepage, not back to the PDP.

   3. ID.me ships its own blocks for cart and checkout, but NOT
      for the product page. The checkout block is already live in
      the Active checkout profile. This bar covers the product
      page, and covers the cart in the same style so the two
      read consistently.

   4. Every anchor has a fallback, so the bar never lands in the
      wrong place if an app is removed or fails to render.

   5. Idempotent and polled — Medpaid renders late, Shopify
      re-renders the buy box on variant change and in the
      editor, and the cart re-renders on quantity change.

   6. Carries the legacy .sl-govx-cta class alongside
      .sl-verify-cta: the styling for this bar still lives under
      the old selector in sl-shared.css. Both names are applied
      so the markup reads correctly and the CSS keeps matching.

   7. The bar deliberately does NOT state the discount amount —
      client rule: the percentage is only revealed after a
      shopper has verified.

   Fails silent: wrong page, no anchor found, or any error, and
   the page is exactly as it is today.
   ============================================================ */
(function () {
  // (2026-09-28) Straight into ID.me's sign-in (Discountify checkpoint for our store),
  // skipping the /pages/idme lander. Do NOT swap in the bare api.id.me/en/session/new
  // login URL: it has no partner context, so the shopper never returns and no discount unlocks.
  var VERIFY_URL = 'https://discountify.id.me/oauth/checkpoint/thesleeploft/verified';

  // Official ID.me logo, served from this theme's assets folder next to this
  // script (the /t/<n>/ theme path changes on every publish, so derive it).
  var SELF = document.currentScript && document.currentScript.src;
  var LOGO = SELF ? SELF.replace(/sl-shared\.js[^\/]*$/, 'idme-logo.svg') : '';

  // (2026-09-28) Card layout matching the Medpaid savings card: ID.me logo +
  // label on top, the five groups as the headline, a gold Verify button and a
  // one-line note. Styles are injected once here so this file stays self-contained;
  // they override the legacy .sl-govx-cta bar styles in sl-shared.css.
  var CSS =
    'a.sl-verify-cta.sl-idme-card{display:block;padding:14px 16px 16px;border-radius:12px;background:#1f2854;color:#fff;text-decoration:none;line-height:1.3;text-align:left}' +
    'a.sl-verify-cta.sl-idme-card:hover{filter:none;transform:none}' +
    'a.sl-verify-cta.sl-idme-card *{color:inherit}' +
    '.sl-idme-card__top{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:9px}' +
    '.sl-idme-card__logo{display:inline-flex;align-items:center;background:#fff;border-radius:999px;padding:5px 11px;line-height:0}' +
    '.sl-idme-card__logo img{height:15px;width:auto;display:block}' +
    '.sl-idme-card__tag{font-size:11.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.75}' +
    '.sl-idme-card__title{display:block;font-size:15px;font-weight:800;line-height:1.35}' +
    '.sl-idme-card__title em{font-style:normal;color:#ffd166 !important}' +
    '.sl-idme-card__cta{display:flex;align-items:center;justify-content:center;margin-top:11px;min-height:42px;border-radius:999px;background:#ffd166;color:#3d2600 !important;font-weight:800;font-size:14px;transition:filter .15s ease}' +
    'a.sl-idme-card:hover .sl-idme-card__cta{filter:brightness(1.06)}' +
    '.sl-idme-card__note{display:block;margin-top:8px;font-size:12px;text-align:center;opacity:.75}';

  function ensureStyle() {
    if (document.getElementById('sl-idme-card-css')) return;
    var st = document.createElement('style');
    st.id = 'sl-idme-card-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function build() {
    ensureStyle();
    var a = document.createElement('a');
    a.className = 'sl-verify-cta sl-govx-cta sl-idme-card';
    a.href = VERIFY_URL;
    a.target = '_blank';
    a.rel = 'noopener';
    var logo = LOGO
      ? '<span class="sl-idme-card__logo"><img src="' + LOGO + '" alt="ID.me" width="44" height="16"></span>'
      : '<span class="sl-idme-card__logo" style="color:#2e3f51;font-weight:800;font-size:13px;line-height:1">ID.me</span>';
    a.innerHTML =
      '<span class="sl-idme-card__top">' + logo +
        '<span class="sl-idme-card__tag">Community discount</span>' +
      '</span>' +
      '<span class="sl-idme-card__title"><em>Exclusive discount</em> for military, first responders, nurses, teachers &amp; students</span>' +
      '<span class="sl-idme-card__cta">Verify with ID.me &rarr;</span>';
    return a;
  }

  /* Product page (or a quick-view popup's buy box): under the Medpaid bar, else above the trust strip. */
  function placeProduct(info) {
    info = info || document.querySelector('.product__info-container');
    if (!info) return false;
    if (info.querySelector('.sl-verify-cta')) return true;

    var med = info.querySelector('.mp-widget');
    var trust = info.querySelector('.sl-pdp-trust');
    var el = build();

    if (med && med.parentNode) {
      med.parentNode.insertBefore(el, med.nextSibling);
      return true;
    }
    if (trust && trust.parentNode) {
      trust.parentNode.insertBefore(el, trust);
      return true;
    }
    return false;
  }

  /* Cart page: directly above the Affirm block (below the Medpaid card when it's there). */
  function placeCart() {
    var blocks = document.querySelector('.cart__footer .cart__blocks');
    if (!blocks) return false;
    if (blocks.querySelector('.sl-verify-cta')) return true;

    // Anchored to the wallet-button row, not to Affirm itself: Affirm is an
    // app block that renders late, so waiting for it would delay or miss the
    // bar. The wallet row is server-rendered and Affirm is its next sibling,
    // so inserting after it lands in the same place, immediately.
    var dyn = blocks.querySelector('.cart__dynamic-checkout-buttons');
    var mp = blocks.querySelector('#mp-cart-card');
    if (mp && mp.parentNode === blocks) {
      blocks.insertBefore(build(), mp.nextSibling);
      return true;
    }
    if (dyn && dyn.parentNode === blocks) {
      blocks.insertBefore(build(), dyn.nextSibling);
      return true;
    }

    // Wallet buttons can be switched off; then sit just under Check out,
    // which is still above Affirm.
    var ctas = blocks.querySelector('.cart__ctas');
    if (ctas && ctas.parentNode === blocks) {
      blocks.insertBefore(build(), ctas.nextSibling);
      return true;
    }
    return false;
  }

  // Quick-view popups (product cards on collection/home pages) load the product's
  // buy box into quick-add-modal's QuickAddInfo-* container; add the bar there too.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var box = records[i].target;
      if (box.id && box.id.indexOf('QuickAddInfo-') === 0) {
        var info = box.querySelector('.product__info-container');
        if (info) placeProduct(info);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  function place() {
    if (/\/products\//.test(window.location.pathname)) return placeProduct();
    if (document.body && document.body.className.indexOf('template-cart') !== -1) return placeCart();
    return true; // neither page: nothing to do, stop polling
  }

  function start() {
    if (place()) return;

    var tries = 0;
    var timer = setInterval(function () {
      if (place() || ++tries > 40) clearInterval(timer);
    }, 125);
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

  document.addEventListener('shopify:section:load', start);
})();
